var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_857_12539",
    transform: "scale(0.0025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_857_12539",
    width: 400,
    height: 400,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQAgMAAAD90d5fAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAJUExURevr67m5udLS0vGr4d8AAAHkSURBVHja7dhNbsIwEMXx2JIX6T4XqOQFt+AIWTBRlhyFS+S+VYGCoe2u70k1/98B+sqMP8YZBgAAAAAAAAAAAAAAAAAAAAAAAACA1bs+YhcRy0mfoU4Z42JRhmzXkDjqf4i0YLcfIvwp6Z6h60ptQuKkr1bErMnIbUYc1GvrzNCSiL2+JaqmPGbEqt4lss4/9V3T+fIcotiO01cr3oTLa7qdWTvdGbnd/7JuDTfdrqqQ3KzbUbVRcvPfZ9VGSe2KUoWM7d6YRJfj2O5yacjSnvqL6FRZHo4YUcjhp9r9dcjaQ0i1hczikN83zb8OKd2EVPmbTnhAfr/vD+KQMIRk3TD8vE1WxwqeDYtL+cHgPuftDS2RPbIfHo+Oai2Oaq2Oas2GamkX1xiGvtcwHI9h6HtytKQ6dslkXMDSgys7qpUc1SqOY74YqnVdXJbrXVuty+yoHlAdE9fgaEk2DEPXEHHfk+OJlRyLKzleP6MtZHWEzD2ElL5CjoS8Zoj4OgHwak76iLwt+pSiv33PjyD1lHoZU9VHvWXuqo4xdXIM3JvjEeT47JwdX1acIftuQjroyWAM6WHHW86uYvtYoH4EZcsjyHHHf9ZLP61Y5i4AAAAAAAAAAAAAAAAAAAAAAAAAAGDzAW3YIi1Gdk+9AAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenPlaceholder);
export default __webpack_public_path__ + "static/media/token-placeholder.06bada5024aa1a5fc6f957ffdde05e73.svg";
export { ForwardRef as ReactComponent };